module.exports = __webpack_public_path__ + "img/tu7.7ff3ad64.png";